module.exports = __webpack_public_path__ + "static/img/temu.52af1ea4.svg";